import {gql} from '@apollo/client'

export const GET_BANK_IMPORT = gql`
  query GetBankImport($bankImportId: ID!) {
    bankImport(id: $bankImportId) {
      id
      name
      createdAt
      importedBy
      fromDate
      toDate
      totalCount
      reconciledCount
      ignoredCount
      deletedCount
      organisation {
        id
        internalName
        internalColor
      }
      downloadUrl
    }
  }
`

export const IMPORT_PAYMENTS = gql`
  mutation ImportPayments($id: ID, $signedBlobId: String, $source: String, $name: String) {
    importPayments(id: $id, signedBlobId: $signedBlobId, source: $source, name: $name) {
      id
    }
  }
`
